export default [
  {
    path: '/admin/trader/signal-automation',
    name: 'SignalAutomation',
    component: () => import('@/views/Admin/Trader/SignalAutomation/Index.vue'),
    meta: {
      pageTitle: 'Signal Automation',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Signal Automation', active: true },
      ],
      resource: 'targets.list',
      action: 'read',
    },
  },
]
